import React, { useState } from "react";

//UI Material
import {
  Button,
  CircularProgress,
  Grid,
  Stack,
  SwipeableDrawer,
} from "@mui/material";

//Helpers
import { typographyForSubtitles } from "../../Helpers/typography";
import { fetchWithTokenJSONPost } from "../../Helpers/network";
import { countries } from "../../Helpers/countries";

//Material Icons
import { Add, Cancel, PersonAdd } from "@mui/icons-material";

//Local components
import Form from "../basics/Form";
import ModalWindow from "../Modal";

//Dict for user roles
const roles = ["COLABORATOR"];

//Dict for user positions
const positions = [
  "Equipo de Producción",
  "Departamento de Ventas",
  "Departamento de Administración",
  "Departamento de Ingeniería y Tecnologías",
  "Departamento de Diseño",
  "Departamento de Mercadeo",
  "Departamento de Comercio",
];

export default function NewUserDrawer({ open, setOpen }) {
  const addUserForm = [
    {
      selection: "textfield",
      id: "user",
      initialValue: "",
      xs: 12,
      md: 4,
      label: "Nombre del usuario",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Nombre del usuario",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "idCard",
      initialValue: "",
      xs: 12,
      md: 4,
      label: "Identificación del usuario",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Identificación del usuario",
      content: [],
      style: {},
    },
    {
      selection: "date_picker",
      id: "birthday",
      initialValue: new Date("01/01/1995"),
      xs: 12,
      md: 4,
      label: "Fecha de nacimiento",
      multiline: false,
      type: null,
      inputProps: {},
      placeholder: "Fecha de entrega",
      content: [],
    },
    {
      selection: "selector",
      id: "nationality",
      initialValue: 4,
      xs: 12,
      md: 4,
      label: "Nacionalidad",
      multiline: false,
      type: null,
      inputProps: {},
      placeholder: "Nacionalidad",
      content: countries,
      style: { minWidth: "100%" },
    },
    {
      selection: "textfield",
      id: "email",
      initialValue: "",
      xs: 12,
      md: 4,
      label: "Correo electrónico",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Correo electrónico",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "phoneNumber",
      initialValue: "",
      xs: 12,
      md: 4,
      label: "Número de teléfono",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Número de teléfono",
      content: [],
      style: {},
    },
    {
      selection: "selector",
      id: "position",
      initialValue: 0,
      xs: 12,
      md: 4,
      label: "Posición",
      multiline: false,
      type: null,
      inputProps: {},
      placeholder: "Posición",
      content: positions,
      style: { minWidth: "100%" },
    },
    {
      selection: "selector",
      id: "role",
      initialValue: 0,
      xs: 12,
      md: 4,
      label: "Tipo de usuario",
      multiline: false,
      type: null,
      inputProps: {},
      placeholder: "Tipo de usuario",
      content: roles,
      style: { minWidth: "100%" },
    },
    {
      selection: "date_picker",
      id: "startedAt",
      initialValue: new Date(),
      xs: 12,
      md: 4,
      label: "Fecha de ingreso",
      multiline: false,
      type: null,
      inputProps: {},
      placeholder: "Fecha de ingreso",
      content: [],
    },
    {
      selection: "textfield",
      id: "address",
      initialValue: "",
      xs: 12,
      md: 4,
      label: "Dirección",
      multiline: true,
      type: "text",
      inputProps: {},
      placeholder: "Dirección",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "emergencyName",
      initialValue: "",
      xs: 12,
      md: 4,
      label: "Nombre de contacto de emergencia",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Nombre de contacto de emergencia",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "emergencyPhone",
      initialValue: "",
      xs: 12,
      md: 4,
      label: "Número de contacto de emergencia",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Número de contacto de emergencia",
      content: [],
      style: {},
    },
  ];
  // ==========>Component States<==========
  //State for userData
  const [userData, setUserData] = useState({});
  //State for setting loader for orders data
  const [isLoading, setIsLoading] = useState(false);
  //State for open modal
  const [modalOpen, setModalOpen] = useState(false);
  //State for modal text
  const [modalText, setModalText] = useState("");
  //State for modal description
  const [modalDescription, setModalDescription] = useState("");

  // ==========>Component Functions<==========
  //Function to create new user
  const createNewUser = async () => {
    setIsLoading(true);

    const newUser = {
      user: userData.user,
      email: userData.email,
      birthday: userData.birthday,
      position: positions[userData.position],
      role: roles[userData.role],
      startedAt: userData.startedAt,
      idCard: userData.idCard,
      nationality: countries[userData.nationality],
      address: userData.address,
      phoneNumber: userData.phoneNumber,
      emergency: {
        contact: userData.emergencyName,
        phoneNumber: userData.emergencyPhone,
      },
    };

    try {
      const requestResponse = await fetchWithTokenJSONPost(
        "/users/create-user",
        newUser
      );
      const jsonResponse = await requestResponse.json();

      if (jsonResponse.status === "ok") {
        setModalText("Usuario registrado exitosamente.");
        setModalDescription(jsonResponse.description);
      } else {
        setModalText("No se pudo realizar la acción.");
        setModalDescription(jsonResponse.description);
      }
    } catch (error) {
      console.log(error);
    }
    setModalOpen(true);
    setIsLoading(false);
  };

  return (
    <SwipeableDrawer
      anchor="bottom"
      transitionDuration={600}
      disableSwipeToOpen={true}
      open={open}
      sx={{
        zIndex: "99",
        "& .MuiDrawer-paper": {
          justifyContent: "center",
          borderRadius: "35px 35px 0px 0px",
        },
      }}
      onClose={() => setOpen(false)}
      onOpen={() => {
        /**empty arrow function */
      }}
    >
      <Grid
        container
        justifyContent="center"
        sx={{ padding: "15px" }}
        textAlign="center"
        spacing={1}
      >
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <PersonAdd color="secondary" />
        </Grid>
        <Grid item xs={12}>
          {typographyForSubtitles("Nuevo usuario", "secondary")}
        </Grid>

        <Grid item xs={12}>
          <Form data={addUserForm} handleStateChange={setUserData} />
        </Grid>
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <Stack direction="row" spacing={1} justifyContent="center">
            <Button
              size="small"
              variant="contained"
              color="error"
              sx={{ color: "white" }}
              endIcon={<Cancel />}
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancelar
            </Button>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <Button
                size="small"
                variant="contained"
                color="secondary"
                sx={{ color: "white" }}
                endIcon={<Add />}
                disabled={
                  userData.user === "" ||
                  userData.email === "" ||
                  userData.birthday === "" ||
                  userData.position === "" ||
                  userData.role === "" ||
                  userData.startedAt === ""
                }
                onClick={createNewUser}
              >
                Crear usuario
              </Button>
            )}
          </Stack>
        </Grid>
      </Grid>
      <ModalWindow
        isOpen={modalOpen}
        handleClose={() => setModalOpen(false)}
        title={modalText}
        text={modalDescription}
        leftText="OK"
        leftClick={() => {
          setModalOpen(false);
        }}
      />
    </SwipeableDrawer>
  );
}
